import { useState, type FormEvent } from "react";
import type { HopTierId } from "../api/types";
import { HOP_TIERS } from "../api/types";

type Props = {
  onSearch: (query: string, tier: HopTierId) => void;
  loading: boolean;
  initialQuery?: string;
  initialTier?: HopTierId;
};

export const SearchBar = ({
  onSearch,
  loading,
  initialQuery = "",
  initialTier = "hop1",
}: Props) => {
  const [query, setQuery] = useState(initialQuery);
  const [tier, setTier] = useState<HopTierId>(initialTier);

  const submit = (e: FormEvent) => {
    e.preventDefault();
    const q = query.trim();
    if (!q || loading) return;
    onSearch(q, tier);
  };

  const tierMeta = HOP_TIERS.find((t) => t.id === tier)!;

  return (
    <form
      onSubmit={submit}
      className="panel rounded-2xl p-2 pl-4 flex items-center gap-2 shadow-terminal"
    >
      <span className="font-mono text-flame-400/80 text-sm select-none">
        ⌘
      </span>
      <input
        autoFocus
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="search the knowledge graph…"
        className="flex-1 bg-transparent outline-none text-white placeholder:text-white/30 font-body text-base py-2"
        maxLength={512}
      />
      <div className="hidden md:flex items-center gap-1 pr-1">
        {HOP_TIERS.map((t) => (
          <button
            type="button"
            key={t.id}
            onClick={() => setTier(t.id)}
            className={`px-2.5 py-1 rounded-md font-mono text-[11px] uppercase tracking-wider transition ${
              tier === t.id
                ? "bg-flame-700/60 text-white border border-flame-500/40"
                : "text-white/40 hover:text-white/70 border border-transparent"
            }`}
            title={`${t.description} — ${t.priceLabel}`}
          >
            {t.id}
          </button>
        ))}
      </div>
      <button
        type="submit"
        disabled={loading || !query.trim()}
        className="btn-primary px-5 py-2 rounded-xl font-medium text-sm tracking-wide flex items-center gap-2"
      >
        {loading ? (
          <>
            <span className="w-3 h-3 rounded-full border-2 border-white/40 border-t-white animate-spin" />
            <span>searching</span>
          </>
        ) : (
          <>
            <span>search</span>
            <span className="font-mono text-[11px] opacity-70">
              {tierMeta.priceLabel}
            </span>
          </>
        )}
      </button>
    </form>
  );
};
